(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section-header"] && !Shopify.designMode) return;
  try {
    function aptoOpenWhatsappLinksInNewTab(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]');

    links.forEach(function(link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      aptoOpenWhatsappLinksInNewTab(document);
    });
  } else {
    aptoOpenWhatsappLinksInNewTab(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    aptoOpenWhatsappLinksInNewTab(event.target);
  });

  document.addEventListener('click', function(event) {
    document.querySelectorAll('.apto-header-v2__mobile-menu[open]').forEach(function(menu) {
      if (!menu.contains(event.target)) {
        menu.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.apto-header-v2__mobile-menu[open]').forEach(function(menu) {
        menu.removeAttribute('open');
        var toggle = menu.querySelector('.apto-header-v2__mobile-toggle');
        if (toggle) toggle.focus();
      });
    }
  });

  document.addEventListener('click', function(event) {
    var link = event.target.closest('.apto-header-v2__mobile-panel a');
    if (link) {
      var menu = link.closest('.apto-header-v2__mobile-menu');
      if (menu) menu.removeAttribute('open');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
